import { Navigate, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/sessions")({
    component: () => <Navigate to="/" replace />,
});
